import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=f032499c&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"
import style0 from "./foot.vue?vue&type=style&index=0&id=f032499c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f032499c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f032499c')) {
      api.createRecord('f032499c', component.options)
    } else {
      api.reload('f032499c', component.options)
    }
    module.hot.accept("./foot.vue?vue&type=template&id=f032499c&scoped=true", function () {
      api.rerender('f032499c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/foot.vue"
export default component.exports